// AutoMapper
import "reflect-metadata";
import {
    AutoMapper,
    ProfileBase,
    mapFrom,
    Mapper,
    convertUsing,
    Converter
} from "@nartc/automapper";

// Models
import { DossierDto } from 'app/_mapper/dossier.dto';
import { DossierVm } from 'app/_mapper/dossier.vm';

export class DossierProfile extends ProfileBase {
    constructor(mapper: AutoMapper) {
        super();

        mapper
            .createMap(DossierDto, DossierVm);

        mapper
            .createMap(DossierVm, DossierDto);
    }
}
